import React from "react";
import Tooltip from "../Tooltip";

/**
 * FieldLabel component that renders a label with an optional tooltip
 * 
 * @param {string} label - The label text to display
 * @param {string} description - Optional tooltip content (if provided, shows info icon)
 * @param {string} titleTooltip - Optional title/heading for the tooltip
 * @param {string} htmlFor - Optional htmlFor attribute for the label
 * @param {string} className - Optional additional CSS classes for the label
 * @param {boolean} required - Whether the field is required (shows red asterisk)
 */
const FieldLabel = ({ 
  label, 
  description = null, 
  titleTooltip = null,
  htmlFor = null,
  className = "",
  style = {},
  required = false
}) => {
  if (!label) {
    return null;
  }

  return (
    <label htmlFor={htmlFor} className={className} style={style}>
      {label}
      {required && (
        <span style={{ color: '#FF0000', marginLeft: '4px' }}>*</span>
      )}
      {description && (
        <span style={{ marginLeft: '8px' }}>
          <Tooltip title={titleTooltip} content={description} />
        </span>
      )}
    </label>
  );
};

export default FieldLabel;

